import axios from 'axios';

const getIp = async () => {
  try {
    let ip = await axios.get('https://geolocation-db.com/json/');
    return ip.data;
  } catch (error) {
    console.error('Error getting ip address:', error);
    return {
      IPv4: '127.0.0.1'
    };
  }
};

export default getIp;
